export enum Product {
	kompass = 'Kompass',
	dashboard = 'Dashboard',
	computeExplorer = 'Compute Explorer',
	databaseExplorer = 'Database Explorer',
	zestyDisk = 'Zesty Disk',
	s3Explorer = 'S3 Explorer',
	unusedResources = 'Unused Resources',
	security = 'Security - General Question',
	securityIssues = 'Security Issue',
	insights = 'Insights',
	onboarding = 'Onboarding',
	other = 'Other',
}

export interface SupportFormPayload {
	userName: string;
	userEmail: string;
	organizationName: string;
	productName: string;
	description: string;
	subject: string;
	severity?: SeverityOptions; // available only for Kompass and ZD customers
}

export enum SeverityOptions {
	Critical = 'Critical',
	High = 'High',
	Medium = 'Medium',
	Low = 'Low',
}

export enum RestrictedSupportOrganizations {
	SentinelOne = 4636368130987,
	SentinelOne_2 = 4013007562977,
	VoyagerOneDevops = 2063457744280,
	WebPals = 1221580045796,
	Wirehive = 1984195649528,
	Phylum = 107101134796,
	AllCloudReseller1 = 1927487912150,
}
